import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { CommonService } from './Services/common.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy { 
  resolution: string = '';
  subscription!: Subscription;
  isShowSpinner = false;
  isMObileView = false;
  constructor(
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.onWindowResize();
    this.subscription = this.commonService.isShowSpinner.subscribe(isShow => this.isShowSpinner = isShow);
  }
  
  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    const height = window.innerHeight;
    const width = window.innerWidth;
    this.resolution = height + ' * ' + width;
    if (height > width) {
      this.commonService.setMobileView(true);
      this.isMObileView = true;
    } else {
      this.commonService.setMobileView(false);
      this.isMObileView = false;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
